export default "__VITE_ASSET__C2aq0Zg9__"